import React, { createContext, useContext } from 'react';

const QnAContext = createContext();

export default QnAContext;

export const useQnA = () => useContext(QnAContext);
